import { combineReducers } from 'redux'
import application from './application'
import dashboard from './dashboard'
import apiexecutionstatus from './apiexecutionstatus'



const rootReducer = combineReducers({
   dashboard,
   application,
   apiexecutionstatus
})

export default rootReducer
